import React from 'react';
import { Group, Text, useMantineTheme, rem } from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { IconPhoto, IconUpload, IconX } from '@tabler/icons-react';

const PartnerLogoDropzone = ({ onDrop, onReject, text }) => {

	// State and hooks
	const theme = useMantineTheme();

	return (
		<>
			{/* Dropzone */}
			<Dropzone
				onDrop={onDrop}
				onReject={onReject}
				accept={IMAGE_MIME_TYPE}
				maxFiles={1}
				sx={{ flexGrow: 2 }}
			>
				{/* Layout */}
				<Group
					position="center"
					spacing="xl"
					style={{ minHeight: rem(120), pointerEvents: 'none' }}
				>
					{/* Show on accepted files */}
					<Dropzone.Accept>
						<IconUpload
							size="3.2rem"
							grade={-25}
							color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
						/>
					</Dropzone.Accept>
					{/* Show on rejected files */}
					<Dropzone.Reject>
						<IconX
							size="3.2rem"
							grade={-25}
							color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
						/>
					</Dropzone.Reject>
					{/* Normal state */}
					<Dropzone.Idle>
						<IconPhoto size="3.2rem" grade={-25} />
					</Dropzone.Idle>
					{/* Instructions */}
					<div>
						<Text size="xl" inline ta="center">
							Arrastra cualquier imagen aquí
						</Text>
						<Text size="sm" color="dimmed" inline mt={7} ta="center">
							{text}
						</Text>
					</div>
				</Group>
			</Dropzone>
		</>
	);

}

export default PartnerLogoDropzone;
